import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { BLOG_POSTS } from '../../../blog/blog-posts-token';
import { isHubIndexable } from '../../../blog/hub-indexing';
import { PageCtaComponent } from '../../../content/page-cta/page-cta.component';
import { BRAND_SUFFIX, PageTitleService } from '../../../page-title';
import { RouteUiDataService } from '../../../route-ui-data';
import { SEOService } from '../../../seo.service';
import { BlogPostCardComponent } from '../blog-post-card/blog-post-card.component';

@Component({
  selector: 'app-blog-tag',
  imports: [RouterLink, BlogPostCardComponent, PageCtaComponent],
  templateUrl: './blog-tag.component.html',
  styleUrl: './blog-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlogTagComponent {
  private pageTitle = inject(PageTitleService);
  private seo = inject(SEOService);
  private routeUiData = inject(RouteUiDataService);
  private allPosts = inject(BLOG_POSTS);

  readonly tag = input.required<string>();

  readonly posts = computed(() =>
    this.allPosts.filter((p) => p.tags.includes(this.tag())),
  );

  readonly hasPosts = computed(() => this.posts().length > 0);

  constructor() {
    effect(() => {
      if (!isHubIndexable(this.posts().length)) {
        this.seo.setRobotsNoindex();
      } else {
        this.seo.clearRobots();
      }

      const hashed = `#${this.tag()}`;
      const fullTitle = `${hashed} | Bass Guitar Blog${BRAND_SUFFIX}`;
      this.pageTitle.setPageTitle(fullTitle, { title: hashed });
      this.routeUiData.setBreadcrumbOverride([
        { name: 'Home', path: '/' },
        { name: 'Blog', path: '/blog' },
        { name: hashed },
      ]);
    });
  }
}
